import { jsxs as o, jsx as e } from "react/jsx-runtime";
import * as a from "@radix-ui/react-slider";
import { forwardRef as i } from "react";
const n = i(function({ className: l, ...r }, s) {
  return /* @__PURE__ */ o(
    a.Root,
    {
      ref: s,
      className: [
        "ls-slider",
        "relative flex w-full touch-none select-none items-center",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
        l
      ].filter(Boolean).join(" "),
      style: { height: "var(--space-5)" },
      ...r,
      children: [
        /* @__PURE__ */ e(
          a.Track,
          {
            className: "relative grow overflow-hidden",
            style: {
              height: "var(--space-1)",
              background: "var(--bg-elevated)",
              borderRadius: "var(--radius-pill)"
            },
            children: /* @__PURE__ */ e(
              a.Range,
              {
                className: "absolute h-full",
                style: {
                  background: "var(--accent-default)",
                  borderRadius: "var(--radius-pill)"
                }
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          a.Thumb,
          {
            className: "ls-focus-ring block transition-colors",
            style: {
              width: "var(--space-3)",
              height: "var(--space-3)",
              background: "var(--accent-default)",
              borderRadius: "var(--radius-full)",
              boxShadow: "var(--shadow-sm)"
            },
            "aria-label": r["aria-label"]
          }
        )
      ]
    }
  );
});
export {
  n as S
};
//# sourceMappingURL=Slider-DhuPhhWk.js.map
